import { type MRT_ColumnDef } from 'mantine-react-table';
import React from 'react';
import { CustomChip } from '../../../../../layout/styledcomponents/CustomChip';
import GenericTable from '../../../../shared/GenericTable';

export default function TopBookersListReport(params: any) {
    const columns: MRT_ColumnDef<any>[] = [
        {
            id: 'fullName',
            header: 'Staff',
            accessorFn: (row) => `${row.firstName} ${row.lastName}`,
            mantineTableHeadCellProps: {
                title: 'Users who have completed the most reservations',
            },
        },
        {
            accessorKey: 'email',
            header: 'Email',
        },

        {
            accessorKey: 'isActive',
            id: 'isActive',
            header: 'Status',
            filterVariant: 'select',
            filterFn: (row, _columnId, filterValue) => {
                if (filterValue === '') return true; // no filter applied
                return String(row.getValue('isActive')) === filterValue;
            },

            mantineFilterSelectProps: {
                data: [
                    { label: 'Enabled', value: 'true' },
                    { label: 'Disabled', value: 'false' },
                ],
                clearable: true,
            },
            mantineTableHeadCellProps: {
                title: 'Users Access',
            },
            Cell: ({ row, cell }) => {
                const status = cell.getValue();

                return (
                    <CustomChip
                        label={status === true ? 'Enabled' : 'Disabled'}
                        color={status === true ? 'green' : 'red'}
                        variant='outlined'
                    />
                );
            },
        },

        {
            accessorKey: 'completedBookings',
            header: 'Completed Reservations',

            mantineTableHeadCellProps: {
                title: 'No. of successfully completed reservations during date range',
            },
        },
    ];

    return (
        <GenericTable
            columns={columns}
            data={params?.data || []}
            tableName='7DAY-Reservations-Report'
            loading={!params?.data}
        />
    );
}
